import React from "react";
import Icon, { type IconProps } from "./icon";

export default function SubmitIcon({ className, width = 24, height = 24 }: IconProps) {
  return (
    <Icon
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5L19 12L12 19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
